/**
 * Cart lines from bundles may set excludeDeliveryFee (virtual / non-shipped items).
 * Delivery fee applies if any line is not exempt.
 */
export function cartRequiresDeliveryFee(cart) {
  if (!cart || cart.length === 0) return false;
  return cart.some((item) => !item.excludeDeliveryFee);
}

export function effectiveDeliveryRate(cart, addressDeliveryRate) {
  if (!cartRequiresDeliveryFee(cart)) return 0;
  const n = Number(addressDeliveryRate);
  return Number.isFinite(n) ? n : 0;
}
